import { render } from "./MasterDataElectricPage.vue?vue&type=template&id=ae490f64&scoped=true"
import script from "./MasterDataElectricPage.vue?vue&type=script&lang=js"
export * from "./MasterDataElectricPage.vue?vue&type=script&lang=js"

import "./MasterDataElectricPage.vue?vue&type=style&index=0&id=ae490f64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae490f64"]])

export default __exports__